import Temp from '@/courier/Temp'

export default class JAndTExpress extends Temp {

    static CODE = 'JNT';

    static NAME_TYPE = {
      'GBKK-GBKK': 1,
      'GBKK-UPC': 2,
      'UPC-GBKK': 3,
      'UPC-UPC': 4,
    }

    constructor() {
        super( JAndTExpress.CODE );
    }

    async getZone( item ){
        let type , from , to
        let cross_price = 0
        let remote_area = 0
        let travel_surcharge = 0
        let fuel_surcharge = 0

        remote_area = super.checkRemoteArea(Number(item.toPostcode))
        travel_surcharge = super.checkTravelSurcharge(Number(item.toPostcode))

        if (travel_surcharge) {
          if (item.weight > 20000) {
            travel_surcharge = 200
          } else if (item.weight > 7000) {
            travel_surcharge = 100
          } else {
            travel_surcharge = 30
          }
        }

        from = { province: item.province.from, district: item.district.from, postcode: String(item.fromPostcode) }
        to = { province: item.province.to, district: item.district.to, postcode: String(item.toPostcode) }

        type = await this.checkRateType({ from, to })

        let fuel_surcharge_data = await super.getFuelSurcharge()

        if (fuel_surcharge_data) {
          const temp = {
            1: 'GBKK-GBKK',
            2: 'GBKK-UPC',
            3: 'UPC-GBKK',
            4: 'UPC-UPC',
          }
          
          fuel_surcharge = fuel_surcharge_data[temp[type]] ? fuel_surcharge_data[temp[type]] : 0;
        }

        return {
          rate_type: type,
          rate_remote_area: remote_area,
          travel_surcharge: travel_surcharge,
          cross_price: cross_price,
          fuel_surcharge
        }
    }

    async filterZone() {
      const url = this._VUE.$API_URL
      let courierPostcodeDetails = JSON.parse(localStorage.getItem('courier_postcode'))
      let cpd = 0
      if (courierPostcodeDetails) {
        cpd = courierPostcodeDetails.version
      } else {
        cpd = 0
      }

      const res = await this._VUE.$http.get(`${url}/shop/${cpd}`,
      {
        headers: {
          Token: localStorage.getItem("access_token")
        }
      })

      if (res.status !== 200) {
        return []
      }

      const { district, province } = res.data.data

      const zone = await this.getZoneName(
        { district, province },
        { district, province }
      )
      if (!zone) {
        return []
      }

      // const originZone = zone.split('_')[0].trim()

      // const filter = Object.keys(JAndTExpress.NAME_TYPE).filter((z) => z.includes(originZone))
      const filter = Object.keys(JAndTExpress.NAME_TYPE)

      return filter
    }

    async checkRateType(item) {
      let from = { ...item.from }
      let to = { ...item.to }
      const zone = await this.getZoneName(from, to)

      const zones = this.getAvaliableZones()
      let type = zones[zone] ? zones[zone] : null

      return type
    }

    async getZoneName(from, to) {
      const gbkkList = ['10', '11', '12']

      const prefixOrig = from.postcode.substring(0, 2)
      const prefixDest = to.postcode.substring(0, 2)

      const isOrigGbkk = gbkkList.includes(prefixOrig)
      const isDestGbkk = gbkkList.includes(prefixDest)

      if (isOrigGbkk && isDestGbkk) {
        return 'GBKK-GBKK'
      } else if (isOrigGbkk && !isDestGbkk) {
        return 'GBKK-UPC'
      } else if (!isOrigGbkk && isDestGbkk) {
        return 'UPC-GBKK'
      } else {
        return 'UPC-UPC'
      }
    }

    checkWeight( courierRates , item , validate ){
      if (!courierRates) {
        return {
          index: -1
        }
      }

        item.index = courierRates.findIndex(rate => {
            return item.weight >= rate.min && item.weight <= rate.max
        })

        return super.checkRules( item , validate );
    }

    checkDimension( dimensionCourier , item , validate ){
        return super.checkCourierDimension( dimensionCourier , item , validate );
    }

    async checkRemoteAreaByCorrectorDest(addressRemote, option){
        return new Promise((resolve) => {
          super.getArea([addressRemote], ['JNTP', 'JNTD'], option).then((res) => {
            let weight = option.weight;
            if (weight < ((option.price && option.price.selectedTier) ? option.price.selectedTier.max : 0)) {
              weight = option.price.selectedTier.max
            }
            let returnRate = {
              isRemote: res.data[option.pickup_type]?(res.data[option.pickup_type].is_remote?50:0):0,
              isTravelArea: 0,
              isIsland: res.data[option.pickup_type]?(res.data[option.pickup_type].is_island?30:0):0
            };

            if (res.data && res.data[option.pickup_type] && res.data[option.pickup_type].is_tourist) {
              if (weight > 20000) {
                returnRate.isTravelArea = 200;
              } else if (weight > 7000) {
                returnRate.isTravelArea = 100;
              } else {
                returnRate.isTravelArea = 30;
              }
            }

            resolve(returnRate);
          });
        });
    }

    getAvaliableZones() {
      return JAndTExpress.NAME_TYPE
    }

    mapAvaliableZoneName(key) {
      const map = {
        'GBKK-GBKK': 'ต้นทาง: กรุงเทพและปริมณฑล ปลายทาง: กรุงเทพและปริมณฑล',
        'GBKK-UPC': 'ต้นทาง: กรุงเทพและปริมณฑล ปลายทาง: ต่างจังหวัด',
        'UPC-GBKK': 'ต้นทาง: ต่างจังหวัด ปลายทาง: กรุงเทพมหานคร',
        'UPC-UPC': 'ต้นทาง: ต่างจังหวัด ปลายทาง: ต่างจังหวัด',
      }

      return map[key]
    }

}
